import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import ActionBarItemWrapper from '../items/ActionBarItemWrapper';
import SubscribeToUnlockTooltip from '../SubscribeToUnlockTooltip';
/** Blocks an action/click on the given action bar button if:
 *  - loggedInOnly: sends the clicking user to sisu if anon
 *  - subscribersOnly: sends the clicking user to purchase the tier if unsubbed or,
 *    if locked-subscribed, just blocks the action
 *  Accepts the same props as ActionBarWrapper, allowing popups to work as normal.
 */ const ActionBarButtonRestricted = ({ button , loggedInOnly , subscribersOnly , deviation , restrictedActionName , tooltip , forceVisibleTooltip , renderPopover , notificationTypes  })=>{
    const { t  } = useTranslation();
    const { isLoggedIn , restrictToLoggedIn  } = useRestrictToLoggedIn();
    const { needsSubscription , isSubscribedButBlocked  } = useSubscriptionTier(deviation);
    if (loggedInOnly && !isLoggedIn) {
        return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
            tooltip: t('actionbar.download.mustLogIn'),
            forceVisibleTooltip: forceVisibleTooltip,
            notificationTypes: notificationTypes
        }, cloneWithUpdateClickBehaviour(button, {
            onClick: restrictedActionName ? restrictToLoggedIn(restrictedActionName) : undefined,
            href: undefined
        }));
    }
    const actionBlockedBySubscription = needsSubscription || isSubscribedButBlocked;
    if (subscribersOnly && actionBlockedBySubscription) {
        return /*#__PURE__*/ React.createElement(SubscribeToUnlockTooltip, {
            deviation: deviation,
            forceVisible: forceVisibleTooltip
        }, cloneWithUpdateClickBehaviour(button, {
            onClick: undefined,
            href: undefined
        }));
    }
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        tooltip: tooltip,
        renderPopover: renderPopover,
        forceVisibleTooltip: forceVisibleTooltip,
        notificationTypes: notificationTypes
    }, button);
};
ActionBarButtonRestricted.displayName = 'ActionBarButtonRestricted';
export default ActionBarButtonRestricted;
function cloneWithUpdateClickBehaviour(button, newProps) {
    return /*#__PURE__*/ React.cloneElement(button, _object_spread(_object_spread_props(_object_spread({}, button.props), {
        download: undefined,
        target: undefined
    }), newProps), button.props.children);
}
